<template>
  <v-sheet flat border class="pa-4 col-sm-12">
    <p class="text-subtitle-1 pt-3 text-primary mb-3">
      <span class="font-weight-bold">Chiller</span>
      - Input values at execution time
    </p>
    <v-row>
      <v-col cols="4">
        <v-text-field
          v-model="localInputData.CurrentDateTime"
          :rules="[isDate]"
          variant="outlined"
          density="compact"
          label="Current Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="localInputData.ReadingDateTime"
          :rules="[isDate]"
          variant="outlined"
          density="compact"
          label="Reading Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="localInputData.DelayInMinutes"
          :rules="[isNumberGreaterThanZero]"
          variant="outlined"
          density="compact"
          label="Delay in Minutes"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-subtitle-2 pt-3 text-primary mb-3">
          <span class="font-weight-bold">Power End Uses - kW</span>
        </p>
      </v-col>
      <v-col cols="4"
             v-for="endUse in endUsesKw"
             :key="endUse.Id"
      >
        <v-text-field
          v-model="endUse.Value"
          :rules="[isNumber]"
          variant="outlined"
          density="compact"
          :label="`kW Value for End Use: ${endUse.Name}`"
          @update:model-value="handleEndUseValueChange(endUse)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-subtitle-2 pt-3 text-primary mb-3">
          <span class="font-weight-bold">Water or Gas End Uses - BTU</span>
        </p>
      </v-col>
      <v-col cols="4"
             v-for="endUse in endUsesBtu"
             :key="endUse.Id"
      >
        <v-text-field
          v-model="endUse.Value"
          :rules="[isNumber]"
          variant="outlined"
          density="compact"
          :label="`BTU Value for End Use: ${endUse.Name}`"
          @update:model-value="handleEndUseValueChange(endUse)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-subtitle-2 pt-3 text-primary mb-3">
          <span class="font-weight-bold">Water End Uses - gallons/minute</span>
        </p>
      </v-col>
      <v-col cols="4"
             v-for="endUse in endUsesGpm"
             :key="endUse.Id">
        <v-text-field
          v-model="endUse.Value"
          :rules="[isNumber]"
          variant="outlined"
          density="compact"
          :label="`Gallons/Minute Value for End Use: ${endUse.Name}`"
          @update:model-value="handleEndUseValueChange(endUse)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="text-subtitle-2 pt-3 text-primary mb-3">
          <span class="font-weight-bold">Temperature Sensors - F</span>
        </p>
      </v-col>
      <v-col cols="4"
             v-for="endUse in endUsesF"
             :key="endUse.Id">
        <v-text-field
          v-model="endUse.Value"
          :rules="[isNumber]"
          variant="outlined"
          density="compact"
          :label="`Temperature (F) for Sensor: ${endUse.Name}`"
          @update:model-value="handleEndUseValueChange(endUse)"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import {
  isNumber,
  isNumberGreaterThanZero,
  hasValue,
  isDate,
} from "@/Core.Patterns/Factory/validationFactory.ts";

export default {
  name: "FooFooTheBestUnicornPocV1",

  created() {
    this.endUsesKw = this.getEndUses("EndUsesKw", "LatestValuesKw");
    this.endUsesBtu = this.getEndUses("EndUsesBtu", "LatestValuesBtu");
    this.endUsesGpm = this.getEndUses("EndUsesGpm", "LatestValuesGpm");
    this.endUsesF = this.getEndUses("SensorsTempF", "LatestValuesF");
  },

  data() {
    return {
      devices: [],
      localInputData: {
        ...this.InputData,
        LatestValuesKw: { ...this.InputData.LatestValuesKw },
        LatestValuesBtu: { ...this.InputData.LatestValuesBtu },
        LatestValuesGpm: { ...this.InputData.LatestValuesGpm },
        LatestValuesF: { ...this.InputData.LatestValuesF },
      },
      endUsesKw: [],
      endUsesBtu: [],
      endUsesGpm: [],
      endUsesF: [],
    };
  },

  props: {
    InputData: {
      type: Object,
      required: true,
      LatestValuesKw: { type: Object },
      LatestValuesBtu: { type: Object },
      LatestValuesGpm: { type: Object },
      LatestValuesF: { type: Object },
    },
    DataSources: {
      type: Array,
      required: true,
    },
  },

  methods: {
    isNumber,
    isNumberGreaterThanZero,
    hasValue,
    isDate,

    getEndUses(endUseName, inputDataProperty) {
      try {
        const safeGet = (id) => {
          // if (this.localInputData != undefined && this.localInputData[inputDataProperty] == undefined)
          //   return this.localInputData[inputDataProperty][id];
          if (this.InputData == undefined || this.InputData[inputDataProperty] == undefined)
            return undefined;
          return this.InputData[inputDataProperty][id];
        };
        const endUses = this.DataSources.find(
          (ds) => ds.Key === endUseName,
        )?.Value.map((v) => ({
          Id: v.Id,
          Name: v.Name,
          Value: safeGet(v.Id),
          SourceListName: inputDataProperty,
        }));
        return endUses;
      } catch (error) {
        console.error("Error in getEndUses:", error);
        return [];
      }
    },

    handleEndUseValueChange(endUse) {
      // console.log(`Value changed for ${endUse.Name}:`, endUse);
      const endUseValue = parseFloat(endUse.Value);
      const sourceName = endUse.SourceListName;
      if (!isNaN(endUseValue)) {
        console.log(`value for ${endUse.Id} of ${sourceName} is ${endUseValue}`);
        // console.log(`this.InputData?.[${sourceName}]`, this.InputData[sourceName]);
        if (this.InputData[sourceName] == undefined)
          this.localInputData[sourceName] = {};
        this.localInputData[sourceName][endUse.Id] = endUseValue;
        // console.debug(
        //   `setting InputData[${sourceName}] value for ${endUse.Id} to ${endUseValue}`,
        //   this.localInputData,
        //   this.InputData);
      }
      this.$emit("update:model", this.localInputData);
    },
  },
};
</script>
